var config = {
  shouldAutoUpdateDataFile: true,
  dataFileAutoUpdateInterval: 60000,
  // 1 min
  featureFlagProviderCDNEndpoint: 'https://cdn.optimizely.com/datafiles/%s.json',
  endPoints: {
    logging: '/api/log'
  }
};

export { config as default };
